import { EntityTypeSupportingPinnedFields } from "@mapmycustomers/shared/types/entity";

import { toPersistedKey } from "../ListRef";
import { MapConfigurationPatch } from "../MapConfigurationPatch";

import { PinnedListsChange } from "./getChangedPinnedLists";

// The `users/me` body for a change: changed lists under `fields`, changed shared lists also as the
// legacy flat names list, and changed flags. Only what changed is sent; the server patches deep
const toMapConfigurationPatch = ({
  actions,
  engagement,
  lists,
}: PinnedListsChange): MapConfigurationPatch => {
  const flatLists: Partial<Record<EntityTypeSupportingPinnedFields, string[]>> = Object.fromEntries(
    lists.flatMap(({ fields, ref }) =>
      ref.kind === "shared" ? [[ref.entityType, fields.map(({ fieldName }) => fieldName)]] : []
    )
  );

  return {
    ...flatLists,
    fields: {
      ...(actions !== undefined && { actions }),
      ...(engagement !== undefined && { engagement }),
      ...Object.fromEntries(lists.map(({ fields, ref }) => [toPersistedKey(ref), fields])),
    },
  };
};

export default toMapConfigurationPatch;
